    <p-dialog
      header="Where Am I Used?"
      [(visible)]="display"
      [draggable]="false"
      [style]="{ width: '70vw', height: '70vh' }"
      (onHide)="closeWhereAmIUsedModal()"
      [modal]="true"
      id="whereAmIUsedModal"
    >
    <app-panel-list
    [noResultFound]="noData"
    [panelList]="whereAmIUsedPanelListInput"
  >
    <ng-template #templateRef let-data="dataVar">
      <div panel-content class="where-am-i-used-panel">
        <!-- Display eQMSScope as a single column -->
        <div class="col-12">
          <div class="col-item-label"><label>eQMS Scope</label></div>
          <b>{{ data?.eQMSScope }}</b>
        </div>
      </div>
    </ng-template>
  </app-panel-list>
  
    </p-dialog>